import { getUser, getToken } from './service/AuthService';
import { getUserGoal } from './service/GoalService';

import Timer from './Timer';
import ProblematicLogEntry from './ProblematicLogEntry';
import TextExpander from './TextExpander';


import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import closeBttn from './assets/closeBttnSquare.svg';
import nextBttn from './assets/nextBttn.svg';

import './css/WellnessGym.css';
import './css/PopupForm.css';

import WellnessGymCard from './WellnessGymCard';

import { DailyPromptTextField } from './MaterialComponents';
import AudioRecorder from './AudioRecorder'
import editBttn from './assets/editBttn.svg';
import GuidedRelapse from './GuidedRelapse'
import Chat from "./ChatDemo2";


import boxedBreathing from './assets/cropped_box_breathing.gif';
import meditationAudio from './assets/general-meditation-wellness-gym.mp3';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';

function convertTimestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const dateString = date.toLocaleDateString('en-US', options)
    //console.log(dateString)
    return dateString;
}

function convertTimestampToFullDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit', // "02"
        minute: '2-digit', // "30"
        second: '2-digit', // "15"
        timeZoneName: 'short' // "GMT+1"
    };
    const dateString = date.toLocaleDateString('en-US', options)
    //console.log(dateString)
    return dateString;
}

const categories = [
  {
    title: 'Guided Journaling',
    page: 0,
    subtitle: 'Explore your thoughts with structured prompts',
    image: '/assets/strength.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Breath Exercise',
    page: 1,
    subtitle: 'Calm your nervous system with mindful breathing',
    image: '/assets/cardio.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Guided Meditation',
    page: 3,
    subtitle: 'Center your mind and body through stillness',
    image: '/assets/stretch.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Wellness Coach',
    page: 2,
    subtitle: 'Get personalized support to reset and refocus',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
  {
    title: 'TH Community',
    page: 6,
    subtitle: 'Share wins and set backs with the community ',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
   {
    title: 'Coming Soon!',
    page: 7,
    subtitle: 'More on the way soon. Stay tuned!',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
];




const WellnessGym = () => {
    // //console.log('getting user goal');
    // //console.log(getUserGoal());

    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [timerHTML, setTimerHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastRelapseDate, setLastRelapseDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const user = getUser();
    //console.log(user)
    const token = getToken();
    const goal = getUserGoal();
    const today = new Date()
    const navigate = useNavigate();
    let logHidden = true;

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [learningContent, setLearningContent] = useState('');
    const [journalAudio, setAudio] = useState(null);
    const [dailyPromptText, setDailyPromptText] = useState('');
    const [dailyJournalBody, setDailyJournalBody] = useState('');
    const [motivationPrompts, setMotivationPrompts] = useState('');
    const [chat, setChat] = useState('')
    const [meditation, setMeditation] = useState('')
    


    const relapseHandler = (event) => {
        event.preventDefault();
        navigate('/relapse');

    }

    function handleAudioState(newValue) {
        setAudio(newValue);
    }

    const handleEditPrompt = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("dailyAudioJournal")[0].style.display =  "none"
        document.getElementsByClassName("audioJournalEdit")[0].style.display =  "flex"
        document.getElementsByClassName("editPromptBttn")[0].style.display =  "none"
        document.getElementsByClassName("doneEditPromptBttn")[0].style.display =  "flex"
    };

    const handleDoneEditPrompt = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("dailyAudioJournal")[0].style.display =  "flex"
        document.getElementsByClassName("audioJournalEdit")[0].style.display =  "none"
        document.getElementsByClassName("editPromptBttn")[0].style.display =  "flex"
        document.getElementsByClassName("doneEditPromptBttn")[0].style.display =  "none"
    };

    const handleWrittenMode = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("audioJournalUI")[0].style.display =  "none"
        document.getElementsByClassName("writtenJournalUI")[0].style.display =  "block"
        document.getElementsByClassName("writtenJournalUIBttn")[0].style.display =  "none"
        document.getElementsByClassName("audioJournalUIBttn")[0].style.display =  "block"
    };

    const handleAudioMode = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("audioJournalUI")[0].style.display =  "block"
        document.getElementsByClassName("writtenJournalUI")[0].style.display =  "none"
        document.getElementsByClassName("writtenJournalUIBttn")[0].style.display =  "block"
        document.getElementsByClassName("audioJournalUIBttn")[0].style.display =  "none"    };

     function handleDailyJournalPrompt(newValue) {
        // let newDailyPrompt = dailyPrompt
        // newDailyPrompt.previousPrompt = newDailyPrompt.textcontent
        // newDailyPrompt.textcontent = newValue
        // newDailyPrompt.status = 'updated'
        // setDailyPrompt(newDailyPrompt);
        setDailyPromptText(newValue);
        // setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
    }

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };


    // const expandLog = () => {
    //     //console.log('clicked yo')
    //     if(logHidden){
    //         document.querySelector('#pastProblematicLog').classList.remove('display-none')
    //         document.querySelector('#logBttn').innerText = "Hide Past Problematc Use"
    //         logHidden = false
    //     }
    //     else{
    //         document.querySelector('#pastProblematicLog').classList.add('display-none')
    //         document.querySelector('#logBttn').innerText = "Show Past Problematc Use"
    //         logHidden = true
    //     }
    // }

    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const togglePlay = () => {
        const audio = audioRef.current;
        if (!audio) return;

        if (isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }
        setIsPlaying(!isPlaying);
        alert(!isPlaying)
    };

    const stopAudio = () => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.pause();
        audio.currentTime = 0;
        setIsPlaying(false);
    };

    const handleSeek = (e) => {
    const audio = audioRef.current;
    if (!audio) return;
    const time = parseFloat(e.target.value);
    audio.currentTime = time;
    };

    const [useTextJournal, setUseTextJournal] = useState(false); // false = audio by default
    const [writtenEntry, setWrittenEntry] = useState('');

    const handleSaveWrittenEntry = () => {
        if (!writtenEntry.trim()) return;
        console.log('Saved written journal:', writtenEntry);
        // Save to backend or state
    };
    const controlButtonStyle = {
        background: 'none',
        border: 'none',
        fontSize: '1.5rem',
        cursor: 'pointer',
        color: '#333',
        padding: '0.5rem',
        };

        const rewindAudio = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = Math.max(0, audioRef.current.currentTime - 10); // go back 10s
        }
        };

        const forwardAudio = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = Math.min(duration, audioRef.current.currentTime + 10); // go forward 10s
        }
        };

    async function fetchRelapseLog(){
         // do stuff here...
        //console.log('fetching the relapse log :)')
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //console.log('here ; wath')

        const moduleParams = {
            mode: 'default'
        };

        //console.log('pre request object <3: ')
        const requestBody = {
            username: user.username,
            token: token,
            module: moduleParams,
        }

        //console.log('request object: ', requestBody)
        setDailyPromptText('What situation keeps repeating in your life? What do you think it’s trying to teach you?')

        setDailyJournalBody(
            <div className="learningFeedback" style={{ maxHeight: '100%' }}>
                <div className="audioJournal">
                    {/* <div className="relapseQuestion">When you will complete the goal by</div> */}
                    {/* <div className="audioJournalEdit">
                        <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Suggested Daily Prompt</div>
                        <DailyPromptTextField id="dailyPrompt" name="dailyPrompt" label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} value={dailyPromptText} />
                    </div> */}
                    <div className="relapseQuestion" style={{textAlign: 'center', marginTop: '1rem'}}> 
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{margin: '0.5rem'}}>Prompt:</div>
                            <button
                                className="editPromptBttn" 
                                onClick={handleEditPrompt}
                                style={{
                                    marginLeft: '1rem',
                                    fontSize: '0.9rem',
                                    borderRadius: '0.5rem',
                                    backgroundColor: '#404040',
                                    border: 'none',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '0.5rem 0.8rem',
                                    gap: '0.4rem', // adds spacing between image and text
                                    color: 'white'
                                }}
                                >
                                {/* <img
                                    className="editBttn"
                                    src={editBttn}
                                    alt="edit"
                                    style={{ height: '16px', width: '16px' }}
                                /> */}
                                <div> ✍️ Edit</div>
                            </button>
                            <button
                                className="doneEditPromptBttn" 
                                onClick={handleDoneEditPrompt}
                                style={{
                                    marginLeft: '1rem',
                                    fontSize: '0.9rem',
                                    borderRadius: '0.5rem',
                                    backgroundColor: '#404040',
                                    border: 'none',
                                    cursor: 'pointer',
                                    display: 'none',
                                    alignItems: 'center',
                                    padding: '0.5rem 0.8rem',
                                    gap: '0.4rem', // adds spacing between image and text
                                    color: 'white'
                                }}
                                >
                                {/* <img
                                    className="editBttn"
                                    src={editBttn}
                                    alt="edit"
                                    style={{ height: '16px', width: '16px' }}
                                /> */}
                                <div> ☑️ Done</div>
                            </button>

                            {/* Toggle Button for Written Mode */}
                            <button
                                className="writtenJournalUIBttn" 
                                onClick={handleWrittenMode}
                                style={{
                                    marginLeft: '1rem',
                                    padding: '0.4rem 0.8rem',
                                    fontSize: '0.9rem',
                                    borderRadius: '0.5rem',
                                    backgroundColor: '#404040',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: 'white'
                                }}
                                >
                                ✏️ Write
                            </button>
                            <button
                                className="audioJournalUIBttn" 
                                onClick={handleAudioMode}
                                style={{
                                    marginLeft: '1rem',
                                    padding: '0.4rem 0.8rem',
                                    fontSize: '0.9rem',
                                    borderRadius: '0.5rem',
                                    backgroundColor: '#404040',
                                    border: 'none',
                                    cursor: 'pointer',
                                    display: 'none',
                                    color: 'white'
                                }}
                                >
                                🎤 Audio
                            </button>
                        </div>
                        <br/>
                        <div className="dailyAudioJournal" style={{textAlign: 'center'}}>{ 'What situation keeps repeating in your life? What do you think it’s trying to teach you?' } </div>
                        <div className="audioJournalEdit" style={{ display: 'none'}}>
                            {/* <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Update daily prompt</div> */}
                            <DailyPromptTextField rows="2" label="Update Prompt" defaultValue={"What situation keeps repeating in your life? What do you think it’s trying to teach you?"} handleChange={handleDailyJournalPrompt} />
                        </div>
                    </div>
                    {/* <div>
                        <div className="relapseQuestion" style={{ marginTop: '1.6rem'}}>Suggested daily prompt</div>
                        <MateriaBasicTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyGoalTitle} />
                    </div> */}
                    {/* <div> <AudioRecorder saveAudio= {handleAudioState} /> </div>   */}
                    <div className="writtenJournalUI" style={{ display: 'none', width: '100%' }}>
                        <div style={{ marginTop: '1rem' }}>
                        <textarea
                            value={writtenEntry}
                            onChange={(e) => setWrittenEntry(e.target.value)}
                            placeholder="Write your thoughts here..."
                            style={{
                            width: '80%',
                            minHeight: '100px',
                            padding: '1rem',
                            fontSize: '1rem',
                            borderRadius: '0.5rem',
                            border: '1px solid #ccc',
                            resize: 'vertical',
                            rows: '3'
                            }}
                        />
                        </div>
                    </div>
                    <div className="audioJournalUI">
                        <div style={{ marginTop: '2rem' }}>
                            <AudioRecorder saveAudio={handleAudioState} />
                            </div>
                    </div>
                    {/* Toggle Button / Text Mode */}
                    {/* <button
                        onClick={() => setShowTextJournal(!showTextJournal)}
                        className="w-full px-4 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 transition"
                    >
                        {showTextJournal ? "Cancel Text Journal" : "Too loud to record?"}
                    </button>
                    {showTextJournal && (
                        <div className="mt-4 p-4 border rounded-md bg-gray-100">
                        <textarea
                            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            placeholder="Write your thoughts here..."
                            value={textJournal}
                            onChange={handleTextChange}
                            rows="4"
                        ></textarea>

                        <button
                            className="mt-2 w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                        >
                            Save Journal Entry
                        </button>
                        </div>
                    )}                  */}
                </div>
                {/* <div className="audioJournalEdit"  style={{ display: 'none'}}>
                    <div>
                        <div className="relapseQuestion" style={{ marginTop: '1.6rem'}}>Suggested daily prompt</div>
                        <MateriaBasicTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} />
                    </div>
                    <div className="formBttnContainer" >
                        <button className="popupButton" style={{ marginBottom: '1rem'}} onClick={handleUpdatePrompt} > Update </button>
                    </div>                  
                </div> */}
                 <div className="formBttnContainer">
                    {/* <button className="popupButton" onClick={handleRelapsePreventionPlan} >Prevention Plan</button> */}
                    {/* <button className="popupButton" onClick={} style={{ marginTop: '1rem' }} >Get Back on Track</button> */}
                    {/* <button className="popupButton" onClick={handleNextQuestion} style={{ marginTop: '1rem' }} >Set Back Journal</button> */}
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleCloseLearningPopup} >Save Journal Entry</button>
                </div>
            </div> 
            
        )

        setMotivationPrompts(
            <div className="learningFeedback" style={{ maxHeight: '100%' }}>
                <div>
                    {/* <p className="questionInfo" style={{marginTop:"0"}}> Take it one intentional step at a time.</p> */}
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}>
                    <div className="relapseQuestion">Let's breathe and recenter. Follow the box breathing pattern on your screen. When you're done click the back to wellness gym and jump back.</div>
                    <img className="learningProgressIcon" src={boxedBreathing} style={{borderRadius: "10rem", height:'240px', width:'240px', marginTop:'1rem'}} alt="Logo" />
                    {/* <div className="guidedRelapse" style={{
                        position: 'absolute',
                        bottom: '6.5rem',
                        right: '5rem',
                        }}>
                            <div> <GuidedRelapse saveAudio= {handleAudioState} /> </div>                   
                    </div> */}
                </div>
                <div className="formBttnContainer" style={{bottom:'0rem'}}>
                    <button className="popupButton" onClick={handleCloseLearningPopup} style={{ marginTop: '1rem' }} >Back to Wellness Gym</button>
                </div>
            </div> 
        )

        setChat(<Chat/>)

        setMeditation(
            <div className="learningFeedback" style={{ maxHeight: '100%' }}>
                <div>
                <p className="questionInfo" style={{ marginTop: "0" }}>
                    Let's slow down. You’re allowed to pause. A few deep breaths can bring you back into balance.
                </p>
                </div>

                <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    marginTop: '1rem',
                }}
                >
                <div className="relapseQuestion" style={{ marginBottom: '1rem' }}>
                    Inhale. Exhale. You're safe here.
                </div>
                {/* <div
                    style={{
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, #d0f0e8, #e8f5e9)',
                    marginTop: '1.5rem',
                    marginBottom: '2rem',
                    animation: 'pulse 6s ease-in-out infinite',
                    }}
                /> */}

                <audio ref={audioRef} src={meditationAudio} preload="auto" />

                {/* <div style={{ width: '100%', maxWidth: '400px', marginTop: '1rem' }}>
                    <input
                    type="range"
                    min="0"
                    max={duration}
                    value={currentTime}
                    onChange={handleSeek}
                    step="0.1"
                    style={{ width: '100%' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#666' }}>
                    <span>{formatTime(currentTime)}</span>
                    <span>{formatTime(duration)}</span>
                    </div>
                </div>

                <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
                    <button className="popupButton" onClick={togglePlay}>
                    {isPlaying ? 'Pause' : 'Play'}
                    </button>
                    <button className="popupButton" onClick={stopAudio}>
                    Stop
                    </button>
                </div> */}
                <AudioPlayer
                    src={meditationAudio}
                    onPlay={e => console.log("onPlay")}
                    style={{ marginTop: '1rem' }}
                    // other props here
                />

                </div>

                <div className="formBttnContainer" style={{ bottom: '0rem' }}>
                <button
                    className="popupButton"
                    onClick={handleCloseLearningPopup}
                    style={{ marginTop: '2rem' }}
                >
                   Back to Wellness Gym
                </button>
                </div>
            </div>
            );


        // setMeditation(
        //     <div className="learningFeedback">
        //         <div>
        //         <p className="questionInfo" style={{ marginTop: "0" }}>
        //             Let's slow down. You’re allowed to pause. A few deep breaths can bring you back into balance.
        //         </p>
        //         </div>

        //         <div
        //         style={{
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //             textAlign: 'center',
        //         }}
        //         >
        //         <div className="relapseQuestion">
        //             Inhale. Exhale. Feel the present moment. You're safe here.
        //         </div>

        //         <div
        //             style={{
        //             width: '200px',
        //             height: '200px',
        //             borderRadius: '50%',
        //             background: 'radial-gradient(circle, #d0f0e8, #e8f5e9)',
        //             marginTop: '1.5rem',
        //             marginBottom: '2rem',
        //             animation: 'pulse 6s ease-in-out infinite',
        //             }}
        //         />

        //         <button
        //             onClick={togglePlayback}
        //             style={{
        //             backgroundColor: '#a5d6a7',
        //             color: '#1b5e20',
        //             border: 'none',
        //             padding: '0.75rem 2rem',
        //             fontSize: '1rem',
        //             borderRadius: '2rem',
        //             cursor: 'pointer',
        //             transition: 'background 0.3s ease',
        //             }}
        //         >
        //             {isPlaying ? 'Pause' : 'Play'}
        //         </button>

        //         <audio ref={audioRef} src={meditationAudio} preload="auto" />
        //         </div>

        //         <div className="formBttnContainer" style={{ bottom: '0rem' }}>
        //         <button
        //             className="popupButton"
        //             onClick={closeBttn}
        //             style={{ marginTop: '1rem' }}
        //         >
        //             Return to Center
        //         </button>
        //         </div>
        //     </div>
        //     );

        return
        axios.post(logFetchUrl, requestBody, requestConfig).then(response => {
            //console.log('relapse log response object: ', response)
            //TODO: through here fetch the daily goal and the big long term goal as well
            // //console.log('returned body')
            // //console.log(`Status: ${response.status}`);
            // //console.log('Body: ', response.data);
            // //console.log('response')
            // //console.log(response.data.dynamoContent[response.data.dynamoContent.length-1])
            //console.log('end date: ', convertTimestampToFullDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseEnd)))
            try {
                setLastImpact(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImpactDescriptionValue)
                setLastLesson(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImprovementText)
                let lastTitleStart = 'Started on '
                let lastTitleEntryDate = convertTimestampToDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseStart))
                let lastTitleTemp = lastTitleStart + lastTitleEntryDate
                setLastTitle(lastTitleTemp)
                setLastRelapseDate(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseEnd))
                setLastDescription(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseDescription)  
                // //console.log('last submit date yooo: ', new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))          
                if(response.data.dynamoContent.length>=1){
                    setLastSubmitDate(new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))
                }
                for (let index = response.data.dynamoContent.length - 1; index >= 0; index--) {
                    const entry = response.data.dynamoContent[index];
                    // //console.log('description: ', entry.relapseDescription)
                    entries.push(<ProblematicLogEntry lastSubmitDate = {new Date(Number(entry.sk)).toString()} lastImpact= {entry.relapseImpactDescriptionValue} lastLesson= {entry.relapseImprovementText} lastDescription= {entry.relapseDescription} lastTitle= {convertTimestampToDateString(Number(entry.problematicUseStart))} />)
                    entries.push(<hr></hr>)
                }
                setEntryHTML(entries)
                setTimerHTML(<div className="item"><Timer lastRelapseDate={lastRelapseDate}/></div>)
            } catch (error) {
                console.log('possibly no entry data yet')
                setEntryHTML(<h3>No Data Yet. As You Use Your Relapse Journal. Your Entries Will Show Here.</h3>)
                setLastTitle(<h4>No Data. Start Using Your Relapse Journal.</h4>)
            }
            // //console.log(entries)
        }).catch(error => {
            //TODO: fix error of receiving null error
            //console.log('returned error')
            console.error('fetch error: ', error);
            setErrorMessage('Sorry the server is down. Please try again later.');
            if(error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else if(error.response.status === 401 ){
                ////console.log('need to login again')
                navigate('/login')
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }
    let questionsLearning = [
        {
            question: 'Guided Journal Entry',
            assets: dailyJournalBody,
        },
        {
            question: 'Breathing Exercise',
            assets: motivationPrompts,
        },
        {
            question: 'Wellness Coach',
            assets: chat,
        },
        {
            question: 'Guided Meditation',
            assets: meditation,
        },
        {
            question: 'Wellness Gym',
            assets: entryHTML,
        },
    ];

    const handleCloseLearningPopup = () => {
        //console.log('trying to close homes')
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };
    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };

    const handleSubmitLearningClosePopup = () => {
        // //console.log('lesss navigate to the home screen homes')
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed

    };

    // const handleOpenLearningPopup = () => {
    //     setShowPopup(true);
    //     document.getElementById('learning-popup').style.display = "block";
    //     document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
    //     document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    // };
    const handleOpenLearningPopup = (pageNumber = 0) => {
        if(pageNumber === 6){
            window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");
            return
        }
        if(pageNumber === 7){
            return
        }
        setShowPopup(true);

        // Set the page number (assumes you track it in state)
        setCurrentQuestion(pageNumber);

        // Show popup UI
        document.getElementById('learning-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility = "visible";
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility = "visible";
    };

    const renderFormLearning = () => {
        try{
            const currentQ = questionsLearning[currentQuestion];
            const { question, options } = currentQ;
            return (
                <div className="formContainer">
                    <div className="button-group" style={{ float: 'right' }}>
                        <button onClick={handleCloseLearningPopup} style={{border:'none'}}> 
                            <img className="closeBttn" src={closeBttn} alt="CloseModalBttn" />
                        </button>
                    </div>
                    <h2 style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '1rem' }}>{question}</h2>
                    <div className="learningTextContent" style={{overflowY: "auto", height: "80%", minHeight:"470px", textAlign: "center"}}> {currentQ.assets} </div>
                    <div className="popupButtonGroup">
                    {/* {currentQuestion > 0 && currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )} */}
                    {/* {currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} >Next</button>
                    ) : (
                        <button id="learningSubmit" className="popupNavigationBttn" onClick={handleSubmitLearning} >Submit</button>
                    )} */}
                    {/* {currentQuestion >= 0 && currentQuestion < questionsLearning.length - 1 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsLearning.length - 1 ? (
                        <button id="relapseSubmit" className="popupNavigationBttn" style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )} */}
                    </div>
                </div>
            );
        
        }
        catch{
            //console.log('some error yo -- need to fix this')
        }
        
    };

    useEffect(() => {    
        fetchRelapseLog()

    }, []) 
    return (
        <div className="wrapper" style={{ marginTop: '6.5rem', marginLeft: '1rem', marginRight: '1rem'}}>
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer" id="learning-popup"  style={{ display: 'none' }} >{renderFormLearning()}</div>
                {/* <div className="popupContainer"  id="regulation-popup"  style={{ display: 'none' }}>{renderFormRegulation()}</div> */}
            </div>
            <div className='donut-parent'>
                <div className="donut"></div>
            </div>
            <div>
                <div>
                    {/* <div className="container"> <button onClick = { relapseHandler }> Log Problematic Use </button> </div> */}
                    {/* <h3 className="container"> Digital Wellness is a journey -- Not a destination</h3> */}
                    <div>
                        <h2 className="text-center"> Pick A Workout And Grow Your Awareness, Self Control, And Resilience</h2>
                    </div>
                    {/* <h4 className="text-center" style={{ marginTop:'0.5rem' }}> <span className="highlight">latest insight:</span> You're always practicing something. Choose growth, curiosity, and love.</h4> */}

                    {/* <p className="text-center"> The why: I will { user.currentGoal }</p> */}
                    {/* <p className="text-center"> Today's goal: { goal.textcontent } </p> */}
                    
                </div>
                <div>
                    <div>
                        <div className="category-container">
                            <div className="grid">
                                {categories.map((cat) => (
                                <div onClick={() => handleOpenLearningPopup(cat.page)} key={cat.title}>
                                    <WellnessGymCard {...cat} />
                                </div>
                                ))}
                            </div>
                        </div>
                        {/* <h4 className="text-center"> Last Set Back: { lastTitle } </h4> */}
                        {/* <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">{name}'s big goal:</span> <TextExpander text={currentGoal} /></h4> */}

                        {/* <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">Latest Insight:</span> <TextExpander text={lastLesson} /></h4>
                        <h6 className="text-center" style={{ marginTop:'0.5rem', marginBottom:'0.5rem' }}> <span > Current Streak: { lastTitle } </span> </h6>
                        <div className="timer-container">
                       
                        <div className="item">
                            <Timer lastRelapseDate={lastRelapseDate}/>
                        </div>
                        </div> */}
                        {/* <p className="text-center"> { lastDescription } </p>
                        <div className="container">
                            <div className="item">
                                Key Lessons
                                <div className='left-text'>
                                    <p> { lastLesson } </p>
                                </div>
                            </div>
                            <div className="item">
                                Impact
                                <div>
                                    <p> { lastImpact } </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    {/* <div> 
                        <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                            <button className="homeBttn" onClick={handleOpenLearningPopup} >Show Set Back Log</button>

                        </div>
                        <br></br>
                        <br></br>
                
                    </div> */}
                </div>
            </div>
            {errorMessage && <p className="message"> { errorMessage } </p>}
        </div>
    )
}

export default WellnessGym;